module.exports = __webpack_public_path__ + "img/nf.801ee09f.svg";